import { service as baseService } from '../../common/configs';
import { values } from './values';
import { ModelStatus } from '../../../library/constants/Code';

export const service = {
  ...baseService,
  makeCategoryOptions: (options, subject) => {
    if (subject === 'total' || !subject || !options) {
      return [];
    }

    const optionList = options?.sdata?.hierachy?.members ?? [];
    const currentMenu = values.menu.find((item) => item.subject === subject);

    const targetMembers =
      optionList.find((item) => item.name === currentMenu.value)?.members ?? [];

    return targetMembers.reduce((acc, cur, idx) => {
      const option = {
        name: cur?.fullName ?? cur.name,
        data: cur.name,
      };

      if (idx === 0) {
        acc.push({ name: '전체', data: '' });
      }
      acc.push(option);
      return acc;
    }, []);
  },
  getFilteredList: (list, subject, category) => {
    if (subject === 'total') {
      return service.sortList(list);
    }
    const subjectCategory = values.menu.find(
      (item) => item.subject === subject
    );

    const test = list
      .filter((item) => {
        const subjectValue = item?.data?.tags?.PostCategoryTag?.middle;
        return subjectValue === subjectCategory.value;
      })
      .filter((item) => {
        if (!category.data) {
          return true;
        }
        const categoryValue = (
          item?.data?.tags?.PostCategoryTag?.leaf ?? []
        ).find((_) => true);

        return categoryValue === category.data;
      });

    return service.sortList(test);
  },
  sortList: (list) => {
    list.sort((a, b) => {
      const aIsFree = service.getIsFree(a);
      const bIsFree = service.getIsFree(b);

      const aIsRecommend = service.getIsRecommend(a);
      const bIsRecommend = service.getIsRecommend(b);

      return (
        bIsRecommend - aIsRecommend ||
        bIsFree - aIsFree ||
        a.data.customOrder - b.data.customOrder
      );
    });

    return list;
  },
  getListForPage: (list, pageNo) => {
    return list.slice((pageNo - 1) * 10, pageNo * 10);
  },
  getIsFree: (item) => {
    const postAttributeTagList = item?.data?.tags?.PostAttributeTag ?? [];

    const attributeTag = postAttributeTagList.find((_) => true);

    return attributeTag === '무료';
  },
  getIsRecommend: (item) => {
    const postAttributeTags = item?.data?.tags?.PostAttributeTag ?? [];

    return !!postAttributeTags.find((item) => item === '추천');
  },
  execDownload: async (file, target) => {
    const anchor = document.createElement('a');

    anchor.setAttribute('href', file.url);
    anchor.setAttribute('download', file.fileName);
    if (target) anchor.setAttribute('target', target);

    anchor.click();
    anchor.remove();
  },
  getDownloadFiles: async (urlList) => {
    if (urlList.length === 0) {
      return;
    }

    const localUrlList = [];
    for (let i = 0; i < urlList.length; i++) {
      const response = await fetch(urlList[i].filePath);

      if (response.status === 200) {
        const dataBlob = await response.blob();

        const url = URL.createObjectURL(dataBlob);
        const fileName = urlList[i].filePath.split('/').pop();

        localUrlList.push({ fileName, url });
      } else {
        return Promise.reject();
      }
    }

    return localUrlList;
  },
  checkAllDownloadable: async (urlList) => {
    if (!urlList || urlList.length === 0) return false;

    for (const url of urlList) {
      const response = await fetch(url.filePath);

      if (response.status === 200) {
        // 다운로드할지 여부만 확인하는 작업이므로 status가 200이면 바로 cancel (안그러면 백그라운드에서 계속 다운로드함)
        await response.body.cancel();
      } else {
        return false;
      }
    }

    return true;
  },
  downloadWithTimeout: (file) => {
    // 연속으로 다운로드를 시도할 경우 1개만 다운로드되므로 0.3초의 시간차 설정
    return new Promise((resolve) =>
      setTimeout(async () => {
        const target = file.url.endsWith('.pdf') ? '_blank' : undefined;
        await service.execDownload(file, target);
        resolve();
      }, 300)
    );
  },
  makePostSubjects: (item, selectedList) => {
    return selectedList.reduce((acc, cur) => {
      const data = {
        html: item.html,
        title: cur.title,
      };

      acc.push(data);
      return acc;
    }, []);
  },
  isAbleDownloadStatus: (student) => {
    const status = student?.status;

    return (
      status === ModelStatus.유료회원 ||
      status === ModelStatus['무료(무결제)회원']
    );
  },
};

export default service;
